import { Component, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SneAnswerService } from 'src/app/services/sne-answer.service';
import { SneAssessmentRecord } from 'src/app/types/sne';
import { findNextAssessmentPath } from '../sne-v2.helpers';

@Component({
  selector: 'ets-sne-landing',
  templateUrl: './sne-landing.component.html',
  styleUrls: ['./sne-landing.component.scss'],
})
export class SneLandingComponent implements OnInit {
  assessmentRecords: SneAssessmentRecord[] = [];
  moduleName: string = '';

  constructor(
    private route: ActivatedRoute,
    private sneAnswerService: SneAnswerService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.moduleName = params['moduleName'];
      this.getAssessmentRecords();
    });
  }
  getAssessmentRecords() {
    this.sneAnswerService.getSneAssessmentRecords().subscribe((assessments) => {
      if (this.moduleName !== '') {
        let completePath = '/sne-new/report/';
        let assessmentStatus = assessments.find(
          (record) => record.assessmentHumanReadableID === this.moduleName.toUpperCase()
        )?.completed;
        if (assessmentStatus) {
          switch (this.moduleName.toUpperCase()) {
            case 'CRT':
              this.router.navigate([completePath + 'CT']);
              break;
            case 'CPS':
              this.router.navigate([completePath + 'CPS']);
              break;

            case 'CCH':
              this.router.navigate([completePath + 'COACHABILITY']);
              break;

            case 'ORC':
              this.router.navigate([completePath + 'OC']);
              break;

            case 'WRC':
              this.router.navigate([completePath + 'WC']);
              break;
          }
        } else {
          this.assessmentRecords = assessments;
          const path = findNextAssessmentPath(
            this.assessmentRecords,
            this.moduleName.toUpperCase()
          );
          if (path) {
            this.router.navigate([path]);
          }
        }
      }
    });
  }
}
